import React, { Component } from 'react';
import axios from "axios";
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
import Waiting from '../../../waiting';
import { appConfig } from '../../../../tools/AppConfig';
import easypaisaLogo from "./../../../../../statics/img/esaypaisa/easypaisa.png";
import paymobLogo from "./../../../../../statics/img/esaypaisa/paymob.png";
import EasypaisaStatus from './../Easypaisa/EasypaisaStatus';
import Countdown360 from 'react-countdown360';
import {decode as base64_decode} from 'base-64';
import jwt_decode from "jwt-decode";
import './../Easypaisa/Easypaisa.css';

const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
    }
};
const phoneV = (value) => {
    if(!validator.isNumeric(value) || value.length != 11 || value.toString()[0] != 0 || value.toString()[1] != 3){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter a valid phone number.</div>;
    }
};

class EasypaisaDirect extends Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            phone: "",
            user_data: "",
            trnx_id: "",
            count_down: true,
            easypaisa_status: "",
            status_message: "",
            redirection_url: "",
            re_inquire_times: 0,
            //public
            waiting: false,
            error: false,
            error_message: "",
        }
    }
    componentDidMount() {
        this.decodePaymentToken()
    }
    
    // decode payment token
    decodePaymentToken = () => {
        // decode from base64 format
        let base64 = base64_decode(this.props.payment_token);
        // decode from jwt format
        let jwt = jwt_decode(base64);
        this.setState({user_data: jwt});
    }
    // pay request
    handlePayRequest = (e) =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + "/api/acceptance/payments/pay";
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source": {
                    "subtype": "EASYPAISADIRECT",
                    "identifier": this.state.phone,
                    "email": this.state.user_data.billing_data.email
                },
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, step: 2, trnx_id: resp.data.id});
            })
            .catch((err)=>{
                this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
            });
        });
        e.preventDefault();
    }
    // inquiry request
    handleInquiryRequest = () =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/transactions/transaction_inquiry';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "transaction_id": this.state.trnx_id,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                // success
                if(resp.data.success == "true" && resp.data.pending == "false" && resp.data.redirection_url){
                    this.setState({easypaisa_status: "success", redirection_url: resp.data.redirection_url});
                // pending
                }else if(resp.data.success == "false" && resp.data.pending == "true" && resp.data.redirection_url){
                    // Max Reinquire Times (3)
                    this.setState({re_inquire_times: this.state.re_inquire_times + 1});
                    if(this.state.re_inquire_times == 3){
                        this.setState({easypaisa_status: "pending", redirection_url: resp.data.redirection_url});
                    }else{
                        this.setState({waiting: false, count_down: true});
                    }
                // fail
                }else if(resp.data.success == "false" && resp.data.pending == "false" && resp.data.redirection_url){
                    this.setState({easypaisa_status: "fail", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }else{
                    this.setState({waiting: false,count_down: false, error: true, error_message: "Something went wrong."});
                }
            })
            .catch((err)=>{
                this.setState({waiting: false,count_down: false, error: true, error_message: "Something went wrong."});
            });
        });
    }
    // handle return back
    handleCancel = () => {
        this.setState({easypaisa_status: "fail", status_message: "Transaction abandoned."});
    }
    renderStep1 = () => (
        <div className="easypaisa_content">
            <VForm onSubmit={this.handlePayRequest}>
                <label>Phone number</label>
                <VInput 
                    type="text"
                    name="phone"
                    value={this.state.phone}
                    onChange={(e)=>this.setState({phone: e.target.value})}
                    validations={[required, phoneV]} 
                />
                <VButton>Proceed</VButton>
            </VForm>
            {this.state.error &&
                <div className="easypaisa_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )
    renderStep2 = () => (
        <div className="easypaisa_content count_down_container text-center">
            {this.state.count_down &&
                <>
                    <h3>Authorization required.</h3>
                    <p>Please approve this transaction in your Easypaisa app to proceed.</p>
                    <Countdown360
                        seconds={this.state.re_inquire_times == 2 ? 10 : 35}
                        borderFillColor="#E8E7E7"
                        borderUnfillColor="#26B15E"
                        borderWidth="3"
                        fontSize="30"
                        fontWeight="normal"
                        clockwise
                        width="158"
                        smooth
                        onComplete={()=>this.handleInquiryRequest()}
                    />
                </>
            }
            {this.state.error &&
                <div className="easypaisa_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )

    render() {
        return (
            <div className="page_container">
                {this.state.easypaisa_status == "" ?
                    <div className="easypaisa_container">
                        {this.state.step == 1 && <span onClick={()=>this.handleCancel()}>X <span>Cancel</span></span>}
                        <div className="easypaisa_header">
                            <img src={easypaisaLogo} alt="Easypaisa"/>
                        </div>
                        {this.state.waiting ?
                            <Waiting height='400px' />
                        :
                            this.state.step == 1 ?
                                this.renderStep1()
                            :
                                this.renderStep2()
                        }
                        <div className="easypaisa_footer">
                            <span>Powered by</span>
                            <img src={paymobLogo} className="paymob" alt="Paymob" />
                        </div>
                    </div>
                :
                    <div className="easypaisa_container">
                        <EasypaisaStatus 
                            easypaisa_status={this.state.easypaisa_status}
                            status_message={this.state.status_message}
                            redirection_url={this.state.redirection_url}
                        />
                        <div className="easypaisa_footer">
                            <span>Powered by</span>
                            <img src={paymobLogo} className="paymob" alt="Paymob" />
                        </div>
                    </div>
                }
            </div>
        )
    }
}
export default EasypaisaDirect;